import { render } from "./updateseating.vue?vue&type=template&id=80f5635a"
import script from "./updateseating.vue?vue&type=script&lang=js"
export * from "./updateseating.vue?vue&type=script&lang=js"

import "./updateseating.vue?vue&type=style&index=0&id=80f5635a&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__